module.exports = __webpack_public_path__ + "static/media/image_2024-10-13_144052092-removebg-preview.7105074f.png";